import { colors } from '../../../theme/styled';
import fontWoff2 from '../../../fonts/BasisGrotesque-Regular.woff2';
import { applyOnEdge } from '../../../shared/utils/browser';

const getFontUrl = () => {
  const host = location.origin;
  return host + fontWoff2;
};

export default {
  layout: 'compact',
  backgroundColor: 'transparent',
  fonts: [
    {
      family: 'BasisGrotesque-Regular',
      src: getFontUrl(),
      style: 'normal',
      weight: '400',
    },
  ],
  styles: {
    // eslint-disable-next-line
    default: {
      container: {
        background: 'transparent',
        marginBottom: '16px',
        top: '8px',
        marginTop: '-8px',
        fontFamily: 'BasisGrotesque-Regular',
      },
      field: {
        height: '56px',
        lineHeight: '24px',
        border: `1px solid ${colors.border}`,
        boxSizing: 'border-box',
        background: 'transparent',
        color: colors.primary,
        fontSize: '18px',
        borderRadius: 0,
        padding: '18px 16px',
        marginTop: '-8px',
        webkitAppearance: 'none',
        fontFamily: 'BasisGrotesque-Regular',
      },
      label: {
        marginBottom: '16px',
        color: colors.primary,
        textTransform: 'none',
        fontSize: '16px',
        lineHeight: '21px',
        fontFamily: 'BasisGrotesque-Regular',
      },
    },
    focus: {
      field: {
        boxShadow: 'none',
      },
    },
    error: {
      field: {
        color: colors.error,
        border: `1px solid ${colors.error}`,
      },
    },
    cv2: {
      container: {
        paddingLeft: '8px',
        width: applyOnEdge('calc(51% - 3px)'),
      },
    },
    expiryDate: {
      container: {
        width: applyOnEdge('49%'),
        marginLeft: applyOnEdge('2px'),
        paddingRight: '8px',
      },
    },
  },
};
